// Adapted from https://github.com/fboeller/microfrontends-with-angular/blob/recording/projects/train-platform/src/micro-frontends/load-micro-frontend.guard.ts
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

import { LoadMfeService } from '@digital-platform/rs-classic/services';
import { RsClassicUiModule } from '../rs-classic-ui.module';

@Injectable({ providedIn: RsClassicUiModule })
export class LoadMfeGuard implements CanActivate {
  private loader = inject(LoadMfeService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const classicMfe = route.data['classicMfe'] as unknown;
    if (typeof classicMfe !== 'string') {
      console.error(`
        The LoadMfeGuard is missing information on which bundle to load.
        Did you forget to provide a classicMfe string as data to the route?
      `);
      return false;
    }

    try {
      await this.loader.loadMfe(classicMfe);

      return true;
    } catch (error) {
      console.error(
        `
        The LoadMfeGuard caught an error while trying to load the bundle for the Classic MFE '${classicMfe}'.
      `,
        { error }
      );
      return false;
    }
  }
}
